import {Component, Input, OnInit} from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { DbmCluAgentParams, StartupInfos_App_CluAgent } from '../clu-agent.models';
import { CluAgentService } from '../clu-agent.service';
import { TYPE_MODELE_IMPRESSION } from 'src/app/app.models';
import { MdBluetoothManager } from '../../bluetooth-printer-utils/md-bluetooth-manager/md-bluetooth-manager.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/@auth/auth.service';
import { AppService } from 'src/app/services/app.service';
import { BluetoothPrinterService } from '../../bluetooth-printer-utils/bluetooth-printer.service';
import { MdCluSettingsStandardPrinterDialogComponent } from '../@modals/md-clu-settings-standard-printer-dialog/md-clu-settings-standard-printer-dialog.component';

@Component({
    selector: 'clu-agent-settings-devices',
    templateUrl: './clu-agent-settings-devices.component.html',
    styleUrls: ['./clu-agent-settings-devices.component.scss'],
})
export class CluAgentSettingsDevicesComponent implements OnInit {
    @Input() onBackoffice = false;
    error: string | null = null;
    errorStartupInfosText: string | null = null;
    loadingStartupInfosText = false;
    errorText: string | null = null;
    loading = false;
    startupInfos: StartupInfos_App_CluAgent | null = null;
    cluParams: DbmCluAgentParams | null = null;
    cluAgentAddressFormControl = new FormControl('http://localhost:4848', [Validators.required]);
    paramsFormGroup = new FormGroup({
        STD_PRINTER_ID: new FormControl(''),
        PRINTER_ID: new FormControl(''),
        DISPLAY_ID: new FormControl(''),
        CASH_BALANCE_ID: new FormControl(''),
    });
    
    constructor(
        private cluAgentService: CluAgentService,
        private authService: AuthService,
        private matDialog : MatDialog, 
        public appService: AppService,
        public btPrinterService: BluetoothPrinterService,
    ) {
    }

    ngOnInit() {
        const cluAgentUrl = this.cluAgentService.getApiEndpointCluAgent();
        if (!!cluAgentUrl) { this.cluAgentAddressFormControl.patchValue(cluAgentUrl); }
        this.cluAgentService.state$.subscribe(infos => {
            this.loading = infos.loading;
            this.startupInfos = infos.startupInfos;
            this.cluParams = infos.cluParams;
            this.errorStartupInfosText = infos.error;

            if (!!this.cluParams) {
                this.paramsFormGroup.patchValue({
                    STD_PRINTER_ID: this.cluParams.STD_PRINTER_ID || '',
                    PRINTER_ID: this.cluParams.PRINTER_ID || '',
                    DISPLAY_ID: this.cluParams.DISPLAY_ID || '',
                    CASH_BALANCE_ID: this.cluParams.CASH_BALANCE_ID || ''
                });
            }
        });
    }

    async doSaveParamsAction() {
        if (this.paramsFormGroup.invalid) { return; }
 
        this.loading = true;
        const params = this.paramsFormGroup.value;
        try {
            await this.cluAgentService.doSaveParamsAction(params);
            await this.cluAgentService.doGetParamsAction();
            this.loading = false;
        } catch(error: any) {
            if (error instanceof Promise) { this.error = await error; } else { this.error = error; }
            this.loading = false;
        }

    }

    async doTestStdPrinterAction() {
        if (!this.paramsFormGroup.controls.PRINTER_ID.value) { return; }
        
        this.loading = true;
        try {
            const printerValue = this.paramsFormGroup.controls.STD_PRINTER_ID.value!;
            const defaultModele = this.onBackoffice == true ? 
                await this.cluAgentService.printerService.doGetDefaultModeleImpressionBO(TYPE_MODELE_IMPRESSION.FACTURE) : 
                await this.cluAgentService.printerService.doGetDefaultModeleImpression(TYPE_MODELE_IMPRESSION.FACTURE, this.authService.AuthSession!);
            if (!defaultModele) { throw "Aucun modèle d'impression par défaut défini"; }
            await this.cluAgentService.printerService.doTestPrinterAction_StandardPrinter(printerValue, defaultModele);
            this.loading = false;
        } catch(error: any) {
            if (error instanceof Promise) { this.error = await error; } else { this.error = error; }
            this.loading = false;
        }
    }

    async doTestPrinterAction() {
        if (!this.paramsFormGroup.controls.PRINTER_ID.value) { return; }
        
        this.loading = true;
        try {
            const printerValue = this.paramsFormGroup.controls.PRINTER_ID.value!;
            const defaultModele = this.onBackoffice == true ? 
                await this.cluAgentService.printerService.doGetDefaultModeleImpressionBO(TYPE_MODELE_IMPRESSION.RECEIPT) : 
                await this.cluAgentService.printerService.doGetDefaultModeleImpression(TYPE_MODELE_IMPRESSION.RECEIPT, this.authService.AuthSession!);
            if (!defaultModele) { throw "Aucun modèle d'impression par défaut défini"; }
            await this.cluAgentService.printerService.doTestPrinterAction_SerialPrinter(printerValue, defaultModele);
            this.loading = false;
        } catch(error: any) {
            if (error instanceof Promise) { this.error = await error; } else { this.error = error; }
            this.loading = false;
        }
    }

    async doTestDisplayAction() {
        if (!this.paramsFormGroup.controls.DISPLAY_ID.value) { return; }
        
        this.loading = true;
        try {
            const displayValue = this.paramsFormGroup.controls.DISPLAY_ID.value!;
            await this.cluAgentService.doTestDisplayAction(displayValue);
            this.loading = false;
        } catch(error: any) {
            if (error instanceof Promise) { this.error = await error; } else { this.error = error; }
            this.loading = false;
        }
    }

    async doConnectCLUAgentAction() {
        if (this.cluAgentAddressFormControl.invalid) { return; }

        this.loading = true;
        try {
            this.cluAgentService.setApiEndpointCluAgent(this.cluAgentAddressFormControl.value!);
            await this.cluAgentService.initConnection();
            this.loading = false;
        } catch(error: any) {
            if (error instanceof Promise) { this.error = await error; } else { this.error = error; }
            this.loading = false;
        }
    }

    doDisconnectCLUAgentAction() {
        this.cluAgentService.disconnectCluAgent();
    }

    async doDisconnectBTDevice() {
        if (this.appService.isMobileApp) {
            this.btPrinterService.disconnectBTDevice();
        } else {
            await this.btPrinterService.disconnectBTDeviceFromWeb();
        }
        this.btPrinterService.btPrinterDeviceConnected = null;
    }

    async doConnectBtPrinter() {
        if (this.appService.isMobileApp) {
            this.matDialog.open(MdBluetoothManager, {
                autoFocus: false, 
                disableClose: true, 
                width: '100%', 
                maxWidth: '600px', 
                data : { } 
            });
        } else {
            try {
                this.loading = true;
                await this.btPrinterService.connectBTDeviceFromWeb();
                this.loading = false;
            } catch(error: any) {
                if (error instanceof Promise) { this.error = await error; } else { this.error = error; }
                this.loading = false;
            }

        }
    }

    doConfigureStandardPrinterAction() {
        this.matDialog.open(MdCluSettingsStandardPrinterDialogComponent, {
            autoFocus: false, 
            disableClose: true, 
            width: '100%', 
            maxWidth: '600px', 
            data : {
                STD_PRINTER_ID: this.paramsFormGroup.controls.STD_PRINTER_ID.value,
            } 
        }).afterClosed().subscribe((result?: any) => {
            if (!result) { return; }
            this.paramsFormGroup.patchValue({
                STD_PRINTER_ID: result.STD_PRINTER_ID
            });
        });
    }
}